<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	title: 'Section Title',
	content: '',
	maxWidth: '720',
	variant: 'default',
	pageHeight: false,
}
const schema = defineSchema({
	title: $.text('Title'),
	content: $.richtext('Content', { simple: true }),
	maxWidth: $.select('Max width', [...CONTENT_WIDTH_OPTIONS], { default: '720' }),
	variant: $.select(
		'Style',
		[
			{ label: 'Default', value: 'default' },
			{ label: 'Store / Product', value: 'store' },
		],
		{ default: 'default' },
	),
	...pageHeightField(false),
})
export const BlockRichText = defineBlock({
	thumbnail: '/block-thumbs/BlockRichText.svg',
	category: 'Content',
	order: 10,
	name: 'BlockRichText',
	label: 'Rich Text',
	icon: 'article',
	schema,
	defaults,
})
</script>
<script setup lang="ts">
import { computed } from 'vue'


import {
	CONTENT_WIDTH_OPTIONS,
	pageHeightClass,
	pageHeightField,
	widthClass,
} from '@/utils/blockLayout'
import RichHtml from '@/components/RichHtml.vue'




const props = defineProps<{
	title?: string
	content?: string
	maxWidth?: string
	variant?: string
	pageHeight?: boolean
}>()

const isStore = computed(() => props.variant === 'store')

const sectionClass = computed(() => {
	// Store variant mirrors the original StoreSection: fixed 760px column, the
	// `storeText` typography, top padding, and mobile side padding.
	if (isStore.value) {
		return [
			'storeText',
			'w760px',
			'mx-auto',
			'pt-3',
			'm_pt-1',
			'txt17',
			'm_txt15',
			'm_px-1',
			pageHeightClass(props.pageHeight),
		]
			.filter(Boolean)
			.join(' ')
	}
	return ['about-section', widthClass(props.maxWidth), pageHeightClass(props.pageHeight)]
		.filter(Boolean)
		.join(' ')
})
</script>

<template>
	<section v-if="!isStore || content" :class="sectionClass">
		<RichHtml :html="content" />
	</section>
</template>

<style></style>
